import { extendTailwindMerge } from "tailwind-merge";
import { SkipInkClasses } from "./src/foundations/typography/skip-ink-classes";
import { TypographyClasses } from "./src/foundations/typography/typography-classes";
import { baseConfig } from "./tailwind-config.base";

/** @type {import('tailwindcss').Config} */
export default {
  ...baseConfig,
  content: ["./src/**/*.{html,js,jsx,ts,tsx}"],
};

export const twMerge = extendTailwindMerge({
  prefix: "tw-",
  extend: {
    classGroups: {
      typography: Object.keys(TypographyClasses).map(
        (key) => `${key.replace(".", "")}`,
      ),
      skipInk: Object.keys(SkipInkClasses).map(
        (key) => `${key.replace(".", "")}`,
      ),
    } as any,
  },
});
